// src/domains/auth.keys.ts（原型既有键 + 0040 偏差块引入的新增键；authT = 本域新增文案对象，模板 t.* 只引用原型字典键）
export const KEYS = [
  'busyLogin', 'busyRs', 'codeBtnText', 'doLogin', 'enBtnStyle', 'hidePwd', 'inTelegram', 'inviteCode', 'isLogin', 'isRegisterMode',
  'loginEmail', 'loginError', 'loginPwd', 'loginTabStyle', 'onInvite', 'onLoginEmail', 'onLoginPwd', 'onRsCode', 'onRsNw', 'onRsNw2',
  'onRsTarget', 'openReset', 'primaryAuthText', 'pwdType', 'registerTabStyle', 'rs', 'rsCdText', 'rsIs1', 'rsIs2', 'rsIs3', 'rsLabel',
  'rsNext', 'rsPh', 'rsPrev', 'rsPrevLabel', 'rsResend', 'rsSteps', 'rsTargetMask', 'rsVias', 'sendCode', 'setModeLogin',
  'setModeRegister', 'showPwd', 'togglePwd', 'zhBtnStyle',
  'authT', 'regCode', 'onRegCode', 'need2fa', 'totpLogin', 'onTotpLogin', 'loginTip', 'termsBoxStyle', 'toggleTerms', 'termsParts', 'showLoginHint',
  'loginHintParts', 'tgLogin', 'showTgBindEmail', 'startBindTg', 'inviteLocked', 'inviteEditable', 'inviteLockedText',
] as const;
export const MODAL_KEYS = ['isReset'] as const;
export const SLICE: string | null = 'a'; // AuthSlice（state: () => ({ a: A0 })）
